import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DataStoreService } from 'src/app/data-store.service';
import { Player, PlayerClass } from 'src/app/models/models';

@Component({
  selector: 'app-player-class-selector',
  templateUrl: './player-class-selector.component.html',
  styleUrls: ['./player-class-selector.component.scss']
})
export class PlayerClassSelectorComponent implements OnInit {

  title?: string;
  player: Player | undefined = undefined;
  classes: PlayerClass[] = []

  constructor(public store: DataStoreService, public bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.classes = this.store.classes.filter(x => x.parent === this.player?.class);
    if (this.classes.length == 0)
      this.classes = this.store.classes.filter(x => x.name === this.player?.class);
  }

  ChangeClass(cl: PlayerClass) {
    if (this.player) {
      this.player.class = cl.name;
      this.player.tier++;
    }

    this.bsModalRef.hide();
  }
}
